<template>
  <section
    v-if="shopifyData.checkSection == 'true'"
    :id="'blog-image-and-text-' + shopifyData.nameOfPage"
    :class="shopifyData.nameOfPage"
    class="image_and_text_sec blog-image-and-text-section"
    :style="{ backgroundColor: backgroundColor }"
  >
    <!-- Sec Content -->
    <div class="sec_content">
      <div class="sec_img">
        <div class="product_popup">
          <img
            v-lazy="shopifyData.secImg.src"
            :src-placeholder="shopifyData.secImg.placeholder"
            :alt="shopifyData.secImg.alt"
            @click="toggle_selection_for()"
          />
          <productPopup
            :product-data="shopifyData.productData"
            :class="{ active: isactive.includes() }"
            @close="toggle_selection_for()"
          />
        </div>
        <h2
          v-if="shopifyData.checkImgHeading == 'true'"
          class="img_text"
          v-html="shopifyData.imgHeading"
        />
        <button
          class="shop_cta subtitle"
          aria-label="Shop CTA"
          @click="toggle_selection_for()"
          v-html="shopifyData.secCta"
        />
      </div>
      <div class="sec_text">
        <p
          v-for="(item, key) in shopifyData.paragraph"
          :key="key"
          class="body_text"
          v-html="item.para"
        />
      </div>
    </div>
  </section>
</template>
<script>
import productPopup from '../product-popup.vue';

export default {
  components: {
    productPopup,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    window.addEventListener('scroll', () => {
      if (document.querySelectorAll('.image_and_text_sec')[1]) {
        const VideoSection = document.querySelectorAll('.image_and_text_sec')[1];
        VideoSection.getBoundingClientRect();
        if (VideoSection.getBoundingClientRect().top < 0) {
          // document.body.classList.remove("active-Bg");
          VideoSection.classList.remove('active');
        } else {
          VideoSection.classList.add('active');
        }
      }
    });
    return {
      isactive: [],
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    backgroundColor() {
      return window.innerWidth <= 768
        ? this.shopifyData.sectionColorMob
        : this.shopifyData.sectionColorDesktop;
    },
  },
  methods: {
    toggle_selection_for(key) {
      if (window.innerWidth <= 768) {
        if (this.isactive.includes(key)) {
          this.isactive = this.isactive.filter((item) => item !== key);
        } else {
          this.isactive.push(key);
        }
      }
    },
  },
};
</script>

<style scoped>
.image_and_text_sec {
  padding: 56px 30px 40px;
}
.image_and_text_sec .product_popup img {
  width: 100%;
}
.sec_content {
  display: flex;
  align-items: flex-start;
  gap: 28px;
  max-width: 940px;
  margin: 0 auto;
}
.sec_img {
  position: relative;
  width: 48%;
}
.sec_img img {
  display: block;
}
.sec_text {
  width: 50%;
}
.img_text {
  font-weight: 700;
  font-size: 100px;
  line-height: 122px;
  letter-spacing: 0.02em;
  color: #ffffff;
  white-space: nowrap;
  text-shadow: 0px 4px 36px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.shop_cta {
  margin-top: 8px;
}
/* Responsive Breakpoints */
@media (max-width: 767px) {
  .sec_img,
  .sec_text {
    width: 100%;
  }
  .sec_text {
    padding: 0 9px 0 13px;
  }
  .image_and_text_sec {
    padding: 0 0px 35px;
  }
  .sec_content {
    flex-direction: column;
    gap: 24px;
  }
  .shop_cta {
    margin: 10px 0 0 13px;
  }
  .sec_img img {
    width: 100%;
  }
  .img_text {
    white-space: break-spaces;
  }
}
</style>
